import { createSelector } from 'reselect'

import { selectCurrentContact } from 'ducks/crm/contacts/selectors/current'
import { selectCurrentCompany } from 'ducks/crm/companies/selectors/current'
import { selectCustomFieldsByCategoryId } from 'ducks/crm/customFields'

import { selectCustomFieldCategoriesById } from './base'

export const selectCurrentContactCustomFieldCategoriesForContactDetailsColumn = createSelector(
  selectCustomFieldCategoriesById,
  selectCustomFieldsByCategoryId,
  selectCurrentContact,
  selectCurrentCompany,
  (categories, fields, contact, company) => {
    return Object.values(categories).map(category => {
      const subject = category.categoryType === 'CONTACT' ? contact : company
      // @TODO needs to be be pushed higher results in new categories and custom fields any time any one of them changes
      const categoryFields = fields[category.id]
      return {
        ...category,
        customFields:
          categoryFields &&
          categoryFields.map(field => {
            const value =
              subject && subject.customFieldValues
                ? subject.customFieldValues[field.key]
                : undefined
            return {
              ...field,
              // eslint-disable-next-line no-underscore-dangle
              subjectId: subject.id,
              valueId: value && value.id,
              value: value && value.value,
            }
          }),
      }
    })
  }
)
